import { PaginationState } from '@tanstack/react-table';
import React, { useEffect } from 'react';

import { useTableExperimentalContext } from './TableExperimentalContext';

type TablePaginationHookProps = {
  setPagination?: React.Dispatch<React.SetStateAction<PaginationState>>;
};

type TablePaginationHook = {
  handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const useTablePagination = (props: TablePaginationHookProps): TablePaginationHook => {
  const { setPagination } = props;
  const { reactTable, pageCount, ref } = useTableExperimentalContext();
  const reactTableState = reactTable.getState();
  const paginationSelect = ref?.current?.getElementsByTagName?.('select')?.[0] as HTMLSelectElement;

  useEffect(() => {
    if (!pageCount) return;

    for (let i = 1; i <= pageCount; i += 1) {
      const option = document.createElement('option');
      paginationSelect?.options?.add(option);
      [option.text, option.value] = [`${i}`, `${i}`];
    }
  }, [paginationSelect, pageCount]);

  useEffect(() => {
    const selectedOption = paginationSelect?.getElementsByTagName?.('option')[reactTableState.pagination?.pageIndex];
    const textMetrics = document?.createElement('canvas')?.getContext('2d')?.measureText(selectedOption?.innerText);
    if (!selectedOption || !textMetrics) return;

    selectedOption.selected = true;
    const baseWidth = 7;
    paginationSelect.style.width = `${baseWidth + textMetrics?.width}px`;
  }, [paginationSelect, reactTableState.pagination?.pageIndex]);

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { target: t } = e;
    const newPageIndex = Number(t.value) - 1;
    const selectedOption = paginationSelect?.getElementsByTagName?.('option')[newPageIndex];

    if (!selectedOption) return;

    selectedOption.selected = true;
    setPagination?.({
      pageIndex: newPageIndex,
      pageSize: reactTableState?.pagination?.pageSize
    });
  };

  return { handleSelectChange };
};

export default useTablePagination;
